import packageJson from '../../package.json';

// Webpack will replace __DEVELOPMENT__ at build time via DefinePlugin
declare const __DEVELOPMENT__: boolean;

const development = __DEVELOPMENT__;

export const Environment = {
	appVersion: packageJson.version,
	development,
	firebaseProjectId: development ? 'mind-game-dev' : 'mind-game-prod',
	testing: false,
	gameName: 'Mind Clash',
	supportEmail: 'games@mindaustralia.org.au',
};

export function chooseDevOrProd<T>(data: { development: T, production: T; }): T {
	return data[Environment.development ? 'development' : 'production'];
}

/** 
 * Boolean value that will never be true in production
 * e.g. const USE_LOCAL_FUNCTIONS = devSwitch(true);
 * @see /lint/NoDevSwitchTrue.ts
 */
export function devSwitch(enabled: boolean): boolean {
	return Environment.development && enabled;
}